import { ComponentType, Overlay, ConnectionPositionPair } from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { Injectable, InjectionToken, Injector, TemplateRef, ElementRef, ViewContainerRef } from '@angular/core';

import { PopoverConfig } from './popover-config';
import { PopoverRef } from './popover-ref';
import { PopoverComponent } from './popover/popover.component';

/** Injection token for passing data to the popover */
export const POPOVER_DATA = new InjectionToken<any>('popover.data');

const defaultConfig: PopoverConfig = {
  backdropClass: '',
  disableClose: false,
  panelClass: [],
  panelOffset: 15,
  arrowSize: 20,
};

@Injectable({
  providedIn: 'root',
})
export class PopoverService {
  constructor(private overlay: Overlay, private injector: Injector) {}

  open<D = any>(
    componentOrTemplate: ComponentType<any> | TemplateRef<any>,
    target: ElementRef | HTMLElement,
    config: Partial<PopoverConfig> = {},
    viewContainerRef: ViewContainerRef // Make ViewContainerRef required
  ): PopoverRef<D> {
    const popoverConfig: PopoverConfig = { ...defaultConfig, ...config };

    const arrowSize = popoverConfig.arrowSize || 0;
    const panelOffset = popoverConfig.panelOffset || 0;
    const arrowOffset = arrowSize / 2;
    //Ordered list of preferred positions, from most to least desirable.
    const positions: ConnectionPositionPair[] = [
      //left centered
      {
        originX: 'start',     // left side of the origin element
        originY: 'center',    // vertical center of the origin
        overlayX: 'end',      // right side of the overlay aligns with left of origin
        overlayY: 'center',    // vertical center of overlay
        panelClass: ['right', 'center'],
        // offsetY: panelOffset,
        offsetX: -panelOffset,
      },
      // //above centered
      {
        overlayX: 'center',
        overlayY: 'bottom',
        originX: 'center',
        originY: 'top',
        panelClass: ['bottom', 'center'],
        offsetY: -panelOffset,
        // offsetX: 0,
        // offsetY: 0,
      },

      // //bottom centered
      // {
      //   overlayX: 'center',
      //   overlayY: 'top',
      //   originX: 'center',
      //   originY: 'bottom',
      //   panelClass: ['top', 'center'],
      //   offsetY: panelOffset,
      //   // offsetX: 0,
      //   // offsetY: 0,
      // },
      // {
      //   overlayX: 'start',
      //   overlayY: 'bottom',
      //   originX: 'start',
      //   originY: 'top',
      //   panelClass: ['bottom', 'start'],
      //   offsetY: -panelOffset,
      //   // offsetX: 0,
      //   // offsetY: 0,
      // },

    ];

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(target)
      .withPush(false)
      .withFlexibleDimensions(false)
      .withPositions(positions)
      .withViewportMargin(-160);//otherwise the popover has his top outside the viewport

    const overlayRef = this.overlay.create({
      hasBackdrop: false,
      backdropClass: config.backdropClass,
      panelClass: config.panelClass,
      positionStrategy,
       scrollStrategy: this.overlay.scrollStrategies.reposition(),
      // scrollStrategy: this.overlay.scrollStrategies.close(),
      // scrollStrategy: this.overlay.scrollStrategies.noop(),
    });

    const popoverRef = new PopoverRef(overlayRef, positionStrategy, popoverConfig);

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: PopoverRef, useValue: popoverRef },
        { provide: POPOVER_DATA, useValue: config.data },
      ],
    });

    const popover = overlayRef.attach(
      new ComponentPortal(PopoverComponent, viewContainerRef, injector)
    ).instance;


    if (componentOrTemplate instanceof TemplateRef) {
      popover.attachTemplatePortal(
        new TemplatePortal(componentOrTemplate, viewContainerRef, {
          $implicit: config.data,
          popover: popoverRef,
        })
      );
    } else {
      popover.attachComponentPortal(
        new ComponentPortal(componentOrTemplate, viewContainerRef, injector)
      );
    }

    return popoverRef;
  }

}